import { render, staticRenderFns } from "./marquee.global.vue?vue&type=template&id=11a703ee&"
import script from "./marquee.global.vue?vue&type=script&lang=js&"
export * from "./marquee.global.vue?vue&type=script&lang=js&"
import style0 from "./marquee.global.vue?vue&type=style&index=0&id=11a703ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports